import { Avatar } from '@equip.health/ui';
import ProviderAvatarTooltipWrapper from '~/components/common/ProviderAvatarBlockTooltipWrapper';
import { useGetProviderInfoWithHistoryByIdQuery } from '~/store/services/providers';

type UseProviderAvatarOptions = {
  providerId?: string;
  size?: '2xs' | 'xs' | 'sm' | 'md' | 'lg';
  placement?: 'left' | 'right' | 'top' | 'bottom';
};

export const useProviderAvatar = ({
  providerId,
  size = 'xs',
  placement = 'left',
}: UseProviderAvatarOptions) => {
  const { data: provider } = useGetProviderInfoWithHistoryByIdQuery(
    {
      providerExternalId: providerId || '',
      includeAvatar: true,
      includeOutOfOffice: true,
      includeProviderHistory: false,
    },
    { skip: !providerId },
  );

  const firstName = provider?.firstName ?? '';
  const lastName = provider?.lastName ?? '';
  const avatarSrc = provider?.avatar?.thumbnailUrl ?? null;

  const providerDisplayName =
    firstName && lastName ? `${firstName} ${lastName}` : null;

  const avatarElement = (
    <Avatar
      name={providerDisplayName}
      size={size}
      src={avatarSrc}
      textSize={size}
      userType="provider"
    />
  );

  const avatarWithTooltip = provider ? (
    <ProviderAvatarTooltipWrapper
      key={providerId}
      onAvatarHover={() => {}}
      placement={placement}
      providerExternalId={providerId || ''}
    >
      {avatarElement}
    </ProviderAvatarTooltipWrapper>
  ) : (
    avatarElement
  );

  return {
    provider,
    providerDisplayName,
    avatarElement,
    avatarWithTooltip,
  };
};
